import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import Range from "../classes/Range";
import TextView from "./TextView";
import HorizontalLine from "./HorizontalLine";
import { BuildContext } from "../classes/BuildContext";

export interface PopupWrapperViewProps extends BaseUIProps {
  key?: string;
  title?: string;
  content?: ReactNode;
  buttons?: Array<ReactNode>;
}

class _PopupWrapperViewState extends ObservableComponent<PopupWrapperViewProps> {
  static defaultProps = { title: "" };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: PopupWrapperViewProps) {
    super(props);

    this.initState();
  }
  public get title(): string {
    return this.props.title;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["buttonsCount", "contentPresent", "title"], this.rebuild);
  }
  public componentDidUpdate(prevProps: PopupWrapperViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.title !== this.props.title) {
      this.fire("title", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      mainAxisSize: ui.MainAxisSize.min,
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      children: [
        this.title !== null && this.title.isNotEmpty
          ? ui.Row({
              mainAxisAlignment: ui.MainAxisAlignment.start,
              children: [
                TextView({
                  data: this.title,
                  textAlign: cStyle.tTextViewHeadingTextAlignOn,
                  style: new ui.TextStyle({
                    color: cStyle.tTextViewHeadingColorOn,
                    fontSize: cStyle.tTextViewHeadingFontSizeOn,
                    fontWeight: cStyle.tTextViewHeadingFontWeightOn,
                  }),
                  className: "xcf7",
                  key: "0",
                }),
              ],
              className: "x49 hc h",
            })
          : [],
        HorizontalLine({
          states: ui.joinStates(
            { "data-visibility": this.title !== null && this.title.isNotEmpty },
            {}
          ),
          className: "xa46 hc h",
          key: "1",
        }),
        this.contentPresent
          ? ui.Container({ child: this.props.content, className: "xb18 hc h" })
          : [],
        this.buttonsCount > 0
          ? HorizontalLine({ className: "x16 hc h" })
          : ui.Container({ className: "xafa hc vc" }),
        this.buttonsCount > 0
          ? ui.Row({
              mainAxisAlignment: ui.MainAxisAlignment.start,
              children: [
                ui.Wrap({
                  alignment: ui.WrapAlignment.start,
                  spacing: 10,
                  crossAxisAlignment: ui.WrapCrossAlignment.center,
                  children: [
                    Range.to(this.buttonsCount).expand((index) => [
                      this.props.buttons[index],
                    ]),
                  ],
                  key: "0",
                }),
              ],
              className: "x65 hc h",
            })
          : [],
      ],
      className: ui.join(this.props.className, "PopupWrapperView xe87 hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public get contentPresent(): boolean {
    return this.props.content != null;
  }
  public get content(): ReactNode {
    return this.props.content;
  }
  public get buttonsCount(): number {
    return this.props.buttons == null ? 0 : this.props.buttons.length;
  }
  public get buttons(): Array<ReactNode> {
    return this.props.buttons;
  }
}
export default function PopupWrapperView(props: PopupWrapperViewProps) {
  return React.createElement(
    _PopupWrapperViewState,
    { ..._PopupWrapperViewState.defaultProps, ...props },
    ...React.Children.toArray(props.buttons)
  );
}
